<template>
	<div>
		<vxe-modal v-model="modal_model" :title="modal_title" :width="modal_width" :height="modal_height" @show="modal_onshow"
			show-footer @hide="modal_onhide" destroy-on-close transfer>
			<template #default>
				<div ref="logistictrace_custom_form"></div>
			</template>
			<template #footer>
				<vxe-button status="" content="返回" @click="modal_cancel"></vxe-button>
				<vxe-button status="primary" content="确认" @click="submit"></vxe-button>
			</template>
		</vxe-modal>
	</div>
</template>
<style scoped>
	.aside {
		border-right: 1px solid rgb(220, 223, 230);
		box-sizing: border-box;
		padding-bottom: 100px;
	}
</style>
<script>
	const formjson = {
		title: '表单',
		rule: {
			"width": "800",
			"height": "600",
			"fApi": [],
			"rule": [{
				"type": '$input',
				"field": 'basDistrFeeUid',
				"title": 'basDistrFeeUid',
				"hidden":true
			},{
				"type": '$datePicker',
				"field": 'range_time',
				"title": '时间范围',
				"hidden":false,
				"validate": [{
					"required": true
				}],
			},{
				"type": '$input',
				"field": 'mark',
				"title": '备注',
				"hidden":false
			},{
				"type": 'group',
				"title": '',
				"field": 'distrFeeRangeList',
				"value": [],
				"props": {
					"rules": [{
						"type": 'col',
						"field": 'col',
						"title": '',
						"style": {
							"margin": '20px 0',
						},
						"children": [{
								"type": 'div',
								"field": 'div',
								"title": '重量区间(kg)',
								"children": [{
									"type": '$inputNumber',
									"field": 'min',
									"name": "min",
									"title": '',
									"value": '',
									"validate": [{
										"required": true
									}],
									"props": {
										"precision": 4,
										"placeholder": '',
									},
									"col": {
										"span": 5,
										"offset": 0
									}
								}, {
									"type": 'div',
									"field": '——',
									"children": ['——'],
									"style": {
										"textAlign": 'center',
									},
									"col": {
										"span": 2,
										"offset": 0
									}
								}, {
									"type": '$inputNumber',
									"field": 'max',
									"name": "max",
									"title": '',
									"value": '',
									"props": {
										"precision": 4,
										"placeholder": '',
									},
									"col": {
										"span": 5,
										"offset": 0
									}
								}],
								"col": {
									"span": 24,
									"offset": 0
								}
							},
							{
								"type": 'div',
								"field": 'div',
								"title": '',
								"style": {
									"marginLeft": '10px',
								},
								"children": [{
									"type": '$inputNumber',
									"field": 'firstWeight',
									"name": "firstWeight",
									"title": '首重(kg)',
									"value": '',
									"props": {
										"placeholder": '',
									},
									"col": {
										"labelWidth": "80px",
										"span": 6,
										"offset": 0
									}
								}, {
									"type": '$inputNumber',
									"field": 'fee',
									"name": "fee",
									"title": '费用(￥)',
									"value": '',
									"props": {
										"precision": 4,
										"placeholder": '',
									},
									"col": {
										"labelWidth": "80px",
										"span": 6,
										"offset": 0
									}
								}, {
									"type": '$inputNumber',
									"field": 'nextWeight',
									"name": "nextWeight",
									"title": '续重(￥)',
									"value": '',
									"props": {
										"precision": 4,
										"placeholder": '',
									},
									"col": {
										"labelWidth": "80px",
										"span": 6,
										"offset": 0
									}
								}, {
									"type": '$inputNumber',
									"field": 'nextFee',
									"name": "nextFee",
									"title": '续费(￥)',
									"value": '',
									"props": {
										"precision": 4,
										"placeholder": '',
									},
									"col": {
										"labelWidth": "80px",
										"span": 6,
										"offset": 0
									}
								}],
								"col": {
									"span": 24,
									"offset": 0
								}
							}
						]
					}]
				},

			}],
			"option": {
				"form": {
					"labelWidth": "90px",
					"hideRequiredAsterisk": false,
					"showMessage": false,
					"inlineMessage": false
				},
				"global": {
					"*": {
						"props": {
							"el": true,
							"size": "mini",
							"disabled": false
						},
						"col": {
							"span": 24,
							"offset": 0
						}
					},
					"el-divider": {
						"wrap": {
							"show": false
						},
						"native": false,
						"col": {
							"span": 24,
							"offset": 0
						},
						"props": {
							"contentPosition": "left"
						}
					}
				},
				"submitBtn": false,
				"resetBtn": false
			}
		}
	}
	import modalMixins from '@_system/components/base/mixins/modal/modal.js'
	export default {
		mixins: [modalMixins],
		props: {
			row: {
				default: () => {
					return {}
				}
			},
			otherrow: {
				default: () => {
					return null
				}
			}
		},
		data() {
			return {
				modal_model: false,
				modal_title: '运费设置',
				modal_width: 800,
				modal_height: 600,
				detailTreeKey: Math.random()
				// list_footerField:[
				// 	{field:'needamount',toFixed:2}
				// ]
			}
		},
		watch: {

		},
		computed: {
			device() {
				return window.systemMethods.device()
			}
		},
		created() {

		},
		mounted() {
			
		},
		methods: {
			modal_init() {
				console.log(this.otherrow)
				if(!this.otherrow){
					this.modal_title = '新增运费设置'
					this.sourceData = {
						distrFeeRangeList:JSON.parse(JSON.stringify(this.row.distrFeeRangeList)),
						basDistrFeeUid:this.row.basDistrFeeUid
					}
					
				}else{
					this.modal_title = '编辑运费设置'
					this.sourceData = {
						distrFeeRangeList:JSON.parse(JSON.stringify(this.otherrow.distrFeeRangeList?this.otherrow.distrFeeRangeList:this.row.distrFeeRangeList)),
						basDistrFeeUid:this.otherrow.basDistrFeeUid,
						mark:this.otherrow.mark,
						range_time:[this.otherrow.begin_time * 1000,this.otherrow.end_time * 1000]
					}
				}
				this.detailTreeKey = Math.random()
				let formData = JSON.parse(JSON.stringify(formjson))
				let rule = formData.rule.rule
				let option = formData.rule.option
				option.el = this.$refs.logistictrace_custom_form
				this.fApi = this.$formCreate(rule, option)
				this.fApi.nextTick(() => {
					this.regestevent(rule)
					this.setFormData()
				})
				this.$emit('show')
			},
			regestevent(rule) {
				rule.forEach((item) => {
					if (item.field) {
						let on = {}
						if (typeof this[item.field + 'Input'] === 'function') {
							on.input = this[item.field + 'Input']
						}
						if (typeof this[item.field + 'Change'] === 'function') {
							on.input = this[item.field + 'Change']
						}
						if (typeof this[item.field + 'Button'] === 'function') {
							on.inputButtonclick = this[item.field + 'Button']
						}
						this.fApi.updateRule(item.field, {
							on: on
						})
					}
				})
			},
			setFormData() {
				if (this.sourceData) {
					let fields = this.fApi.fields()
					fields.forEach((item) => {
						this.fApi.setValue(item, this.sourceData[item])
					})
				}
			},
			getgrid() {
				return this.$refs.list
			},
			add() {
				this.getgrid().insert({})
			},
			delete(row) {
				this.getgrid().remove(row)
			},
			submit() {
				this.fApi.submit((formData) => {
					let submitData = JSON.parse(JSON.stringify(formData))
					this.submitDataFormater(submitData)
					
					this.$api.parcel.saveotherdetail({
						id:this.otherrow ? this.otherrow.id : null,
						mark:submitData.mark,
						range_time: submitData.range_time,
						basDistrFeeUid: submitData.basDistrFeeUid,
						distrFeeRangeList: submitData.distrFeeRangeList
					}).then(() => {
						this.$emit('success')
						this.modal_cancel()
					})
					
					console.log(submitData,90)
				})
			},
			submitDataFormater(formData) {
				for (let i in formData) {
					if (i.match(/^\$son/)) {
						for (let j in formData[i]) {
							formData[i][j].forEach((item) => {
								for (let k in item) {
									if (k.match(/.*time$/g)) {
										item[k] = item[k] / 1000
									}
								}
							})
						}
					} else if (i.match(/.*time$/g)) {
						
						if(Array.isArray(formData[i])){
							formData[i] = formData[i].map((item)=>{
								return item/1000
							})
						}else{
							formData[i] = formData[i] / 1000
						}
						
					}
				}
			},
			reset() {
				//this.init()
			}
		},
		components: {
			
		}
	}
</script>